class ShopBySection extends HTMLElement {
  constructor() {
    super()

    this._doInit = this._doInit.bind(this)

    this.autoplay = !!this.hasAttribute('autoplay')
    this.autoplayInterval =
      Number(this.getAttribute('autoplay-interval')) || 5000
  }

  connectedCallback() {
    const option = {
      init: false,
      spaceBetween: 15,
      slidesPerView: 1.8,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      slidesPerGroup: 1,
      navigation: {
        nextEl: '.shop-by-carousel--icon-next',
        prevEl: '.shop-by-carousel--icon-previous',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      a11y: {
        enabled: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 4.5,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
        },
        1200: {
          slidesPerView: 5.5,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
          spaceBetween: 20,
        },
        1600: {
          slidesPerView: 7.5,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
          spaceBetween: 20,
        },
      },
    }
    if (this.autoplay) {
      option.breakpoints['1024'] = {
        ...option.breakpoints['1024'],
        autoplay: {
          enabled: true,
          delay: this.autoplayInterval,
          pauseOnMouseEnter: true,
        },
        loop: true,
      }
      option.breakpoints['1200'] = {
        ...option.breakpoints['1200'],
        autoplay: {
          enabled: true,
          delay: this.autoplayInterval,
          pauseOnMouseEnter: true,
        },
        loop: true,
      }
      option.breakpoints['1600'] = {
        ...option.breakpoints['1600'],
        autoplay: {
          enabled: true,
          delay: this.autoplayInterval,
          pauseOnMouseEnter: true,
        },
        loop: true,
      }
    }

    this.$swiper = new Swiper('.js-shop-by-section-swiper', option)
    this.$swiper.on('init', this._doInit)
    this.$swiper.on('resize', (swiper) => {
      this._doInit()
    })
    this.$swiper.init()
  }

  _doInit() {
    const imgWrapper = this.$swiper.el.querySelector(
      '.shop-by-section--card_image',
    )
    if (imgWrapper) {
      const h = imgWrapper.getBoundingClientRect().height
      this.style.setProperty('--block-height', `${h}px`)
    }
  }
}

customElements.define('shop-by-section', ShopBySection)
